import { VPad } from "@/services/VirtualPad/VPad"

export enum VirtualPadRoles {
  HOST = 'host',
  PAD = 'pad'
}

export enum PadSessionStage {
  NONE = 'none',
  CONNECTED = 'connected',
  CREATED = 'created',
  CLOSED = 'closed'
}

export enum VPadStage {
  NONE = 'none',
  CONNECTING = 'connecting',
  CONNECTED = 'connected',
  SUSPENDED = 'suspend',
  DISCONNECTED = 'disconnected'
}

export interface VPadState {
  id: string
  connectionId: string
  deviceName?: string
  index: number
  isVirtual: boolean
  connected: boolean
  stage: VPadStage
  mapping: GamepadMappingType
  timestamp: number
  buttons: GamepadButton[]
  axes: number[]
}

export enum StandardGamepadButtonIndex {
  A = 0,
  B = 1,
  X = 2,
  Y = 3,
  L1 = 4,
  R1 = 5,
  L2 = 6,
  R2 = 7,
  SELECT = 8,
  START = 9,
  L3 = 10,
  R3 = 11,
  ARROW_UP = 12,
  ARROW_DOWN = 13,
  ARROW_LEFT = 14,
  ARROW_RIGHT = 15,
  HOME = 16
}

export enum StandardGamepadAxisIndex {
  LEFT_HORIZONTAL = 0,
  LEFT_VERTICAL = 1,
  RIGHT_HORIZONTAL = 2,
  RIGHT_VERTICAL = 3,
}

export enum PadManagerEventType {
  VPAD_CONNECTED = 'vpadConnected',
  VPAD_DISCONNECTED = 'vpadDisconnected',
  VPAD_ERROR = 'vpadError',
  MAX_PADS_REACHED = 'vpadMaxPadsReached'
}

export type PadManagerEvent =
  | {
      type: PadManagerEventType.VPAD_CONNECTED
      connectionId: string
    }
  | {
      type: PadManagerEventType.VPAD_DISCONNECTED
      connectionId: string
    }
  | {
      type: PadManagerEventType.VPAD_ERROR
      connectionId: string
      error: unknown
    }
  | {
      type: PadManagerEventType.MAX_PADS_REACHED
      connectionId: string
    }

export type PadManagerEventListener = (event: PadManagerEvent) => void

export interface VPadHTML5Config {
  sessionId: string,
  vpadList: VPadState[],
  leaveVPad: (connectionId: string) => void
}